import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AdminNavigation from './components/AdminNavigation';
import Footer from './components/Footer';
import PullToRefresh from './components/PullToRefresh';
import SettingsForm from './components/settings/SettingsForm';
import ChangePasswordForm from './components/settings/ChangePasswordForm';

function Settings() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [success, setSuccess] = useState('');

  // Surface a success message routed in from the OAuth callback (?message=...).
  useEffect(() => {
    const message = searchParams.get('message');
    if (message) {
      setSuccess(decodeURIComponent(message));
      setTimeout(() => {
        navigate('/settings', { replace: true });
        setSuccess('');
      }, 5000);
    }
  }, [searchParams, navigate]);

  const handleRefresh = async () => {};

  return (
    <PullToRefresh onRefresh={handleRefresh}>
      <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden bg-background-light dark:bg-background-dark">

        <AdminNavigation />

        <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
            Settings
          </h1>

          {success && (
            <div className="mb-6 rounded-lg bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 p-4">
              <p className="text-sm text-green-800 dark:text-green-200">{success}</p>
            </div>
          )}

          <div className="space-y-8">
            {/* Processing automation defaults (spec 010 US3) — per-user
                toggles for auto chapter audio / auto key points, a default
                voice picker (clears with the "Use system default" sentinel),
                and a free-text TTS model override. */}
            <div className="bg-white dark:bg-background-dark/50 border border-gray-200 dark:border-gray-800 rounded-lg p-6">
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Processing automation
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                Defaults applied to new uploads. You can still override these per file from the Chapters page.
              </p>
              <SettingsForm />
            </div>

            {/* Flow A of the password-reset API: signed in, knows the current
                password. Changing it ends the session. */}
            <div className="bg-white dark:bg-background-dark/50 border border-gray-200 dark:border-gray-800 rounded-lg p-6">
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                Change password
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                You will be signed out once the new password is saved.
              </p>
              <ChangePasswordForm />
            </div>
          </div>
        </main>

        <Footer desktopOnly />
      </div>
    </PullToRefresh>
  );
}

export default Settings;
